import React from 'react';
import { App, AppContext } from '@meronex/app';

import MngMenu from './menu/MngMenu';
import View from '../views/components/View';

export default function Home(props) {
  const { App } = React.useContext(AppContext);

  const { activeView } = props;

  if (activeView !== 'home') {
    return null;
  }

  return (
    <View
      viewId={'home'}
      activeView={activeView}
      showMenu>
      <div className={'home-view'}>
        <div className={'home-tiles'} style={{ paddingTop: '4px', paddingBottom: '8px' }}>
          <MngMenu />
        </div>

        <div
          style={{
            color: '#d0d0d0',
            textAlign: 'center',
            marginTop: '20px',
            paddingBottom: '8px',
            fontSize: '11px',
            letterSpacing: '0.5px',
          }}>
          v{App.metadata.version} &middot; build {App.metadata.build}
        </div>
      </div>
    </View>
  );
}
